<template>
  <v-app>
    <loading></loading>
    <v-content>
      <router-view></router-view>
      <custom-snackbar />
      <legal-terms-dialog
        :isLegalTermsVisible="isLegalTermsVisible"
        mode="save"
      />
<!--      <offline-dialog />-->
    </v-content>
  </v-app>
</template>

<script>
import Loading from '@/components/Loading';
import CustomSnackbar from '@/components/CustomSnackbar';
import LegalTermsDialog from '@/components/legal_terms/LegalTermsDialog';
import OfflineDialog from '@/components/offline/OfflineDialog';

export default {
  name: 'App',
  components: {
    CustomSnackbar,
    Loading,
    LegalTermsDialog,
    OfflineDialog
  },
  computed: {
    isLegalTermsVisible() {
      return this.user.accepted_term_at === null && this.user.user_type === 'User';
    },
    user() {
      return this.$store.getters.currentUser;
    },
  },
};
</script>

<style lang="scss">
  @import "./scss/style";

  .swal2-popup {
    font-family: Ubuntu, sans-serif !important;
  }
</style>
